/*
 * Imports
 */
// lib
// Classes
import MegaMenue from './components/mega-menue';
import SearchTrigger from './components/search-trigger';
// components
import bodySpacing from './components/body-spacing';
import menuIconHandler from './components/menu-icon-handler';
import mobileMenuTrigger from './components/mobile-menue-trigger';
import tabs from './components/tabs';
import widgetFineuploader from './components/widget-fineuploader';
// modules
import scFilter from './modules/sc-filter';
import scProductsDetails from './modules/sc-products-details';
// elements
import ceAccordion from './elements/ce-accordion';
import ceCounter from './elements/ce-counter';


/*
 * execution
 */
// components
bodySpacing();
menuIconHandler();
mobileMenuTrigger();
SearchTrigger;
tabs();
widgetFineuploader();

// modules
scFilter();
scProductsDetails();

// elements
ceAccordion();
ceCounter();

// mega menu
new MegaMenue('.megamenu');
